/**
 * PreviewStore
 * just a little store to handle if we are currently inside a craft preview
 * 
 * in that case we dont want any intro anim, we just want to pass query to our api calls and display the page with the temporary data.
 * 
 * https://...?x-craft-live-preview=OOVZIL95sO
 */
import { whenever } from '@vueuse/core';
import { client } from 'config';
import { defineStore } from 'pinia';
import useRouter from 'plugins/router';
import { pinia } from 'plugins/store/index';
import { computed, ref } from 'vue';

interface IPreviewStore extends Obj{
  active: boolean,
  preview?: string,
  token?: string,
}

const useStore = defineStore('preview', () => {

  const state = ref<IPreviewStore>({
    active: false,
    preview: undefined,
    token: undefined,
  });

  //Actions
  const init = () => {
    if (client) {
      const router = useRouter()
      // wait first change in case.
      whenever(router.currentRoute, () => {
        const route = router.currentRoute;
        if (route.value.query['x-craft-live-preview'] && route.value.query['token']) {
          state.value.preview = route.value.query['x-craft-live-preview'] as string;
          state.value.token = route.value.query['token'] as string;
          state.value.active = true;
        }
      })
    }
  }
 
  return {
    state,
    
    //getters
    active: computed( () => state.value.active), 
    preview: computed( () => state.value.preview),
    token: computed( () => state.value.token),

    //actions
    init,
  }
});

export const store = useStore(pinia);
export default store;
